import MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import { ILabeledDropdownProps } from './UiLabeledDropdown.props';

export interface ILabeledDropdownState {
    selectedIndex: number;
    isShow: boolean;
    indexValue: number;
}

/**
 * Labeled Dropdown component
 */
export default class UiLabeledDropdown extends React.Component<ILabeledDropdownProps, ILabeledDropdownState> {
    public static defaultProps: Partial<ILabeledDropdownProps> = {
        toggleColor: 'link'
    };
    // VSI Customization - START - 24783
    private wrapperRef!: HTMLDivElement | null;
    // VSI Customization - END - 24783

    constructor(props: ILabeledDropdownProps) {
        super(props);
        this._onSelectOption = this._onSelectOption.bind(this);
        const selectedKey = this.props.selectedOption.key;
        const keys = this.props.dropdownOptions.map(option => option.key);
        this.state = { selectedIndex: keys.indexOf(selectedKey), isShow: false, indexValue: 0 };
        this.selectSorting = this.selectSorting.bind(this);
        this.handleDropDown = this.handleDropDown.bind(this);
        // VSI Customization - START - 24783
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        // VSI Customization - END - 24783
    }
    public selectSorting = (values: number): void => {
        this._onSelectOption(values);

        this.setState({
            indexValue: values
        });
    };
    public handleDropDown = (): void => {
        this.setState({ isShow: !this.state.isShow });
    };

    // VSI Customization - START - 24783
    public componentDidMount(): void {
        MsDyn365.isBrowser && document.addEventListener('mousedown', this.handleClickOutside);
    }

    public componentWillUnmount(): void {
        MsDyn365.isBrowser && document.removeEventListener('mousedown', this.handleClickOutside);
    }

    public setWrapperRef = (instance: HTMLDivElement | null): void => {
        this.wrapperRef = instance;
    };

    public handleClickOutside = (event: Event): void => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target as Node | null)) {
            if (this.state.isShow) {
                this.setState({ isShow: false });
            }
        }
    };
    // VSI Customization - END - 24783
    public render(): JSX.Element {
        const { labelText, labelClassname, dropdownId, dropdownOptions /*dropdownClassname*/ } = this.props;

        const labelClassNames = classnames('msc-l-dropdown__label', labelClassname);
        // OOB Available-Currently not using it.
        // const dropdownClassNames = classNames('msc-l-dropdown', dropdownClassname);
        const selectedIndex = this._getSelectedIndex();

        return (
            <div
                role='button'
                className={
                    this.state.isShow
                        ? 'ms-search-result-container__Sort-by-category ms-search-result-arrow-rotate'
                        : 'ms-search-result-container__Sort-by-category'
                }
                onClick={this.handleDropDown}
                // VSI Customization - START - 24783
                ref={this.setWrapperRef}
                // VSI Customization - END - 24783
            >
                <label className={labelClassNames} htmlFor={dropdownId}>
                    {labelText} <span>{dropdownOptions[selectedIndex].value}</span>
                </label>

                {this.state.isShow && (
                    <ul className='ms-serch-result-sorting' tabIndex={0}>
                        {dropdownOptions.map((option, index) => {
                            const values = index;
                            return (
                                <li
                                    role='button'
                                    key={index}
                                    // tslint:disable-next-line: jsx-no-lambda & react-this-binding-issue
                                    onClick={() => this.selectSorting(values)}
                                    className={classnames(
                                        'ms-serch-result-sorting__each-list-item',
                                        selectedIndex === index ? 'ms-serch-result-sorting__bold' : ''
                                    )}
                                >
                                    {option.value}
                                </li>
                            );
                        })}
                        <div className='ms-serch-result-sorting__arrow' />
                    </ul>
                )}

                {/* <select id={dropdownId} className={dropdownClassNames} onChange={this._onSelectOption}>
                        {dropdownOptions.map((option, index) => {
                            const selected = index === selectedIndex;
                            return (
                                <option className='msc-l-dropdown__option' key={option.key} selected={selected} aria-selected={selected}>
                                    {option.value}
                                </option>
                            );
                        })}
                    </select> */}
            </div>
        );
    }

    private _getSelectedIndex(): number {
        if (this.props.controlledByParent) {
            let selectedIndex = -1;
            const selectedKey = this.props.selectedOption.key;
            for (let i = 0; i < this.props.dropdownOptions.length; i++) {
                if (this.props.dropdownOptions[i].key === selectedKey) {
                    selectedIndex = i;
                    break;
                }
            }

            return selectedIndex;
        }

        return this.state.selectedIndex;
    }

    private _onSelectOption(values: number): void {
        const { dropdownOptions, onSelectOption } = this.props;
        const index = values;
        const selectedOption = dropdownOptions[index];
        this.setState({ selectedIndex: index });
        onSelectOption({ selectedOption });
    }
}
